import React from 'react';
import './ProjectsPage.css';
import { useLanguage } from '../i18n/LanguageContext';
import { getProjectsWithTranslations } from '../data/projectsData';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

const ProjectCard = ({ title, description, image, technologies, imagePosition = 'left', link }) => {
  const imageContent = (
    <div className="projects-page__card-image">
      {image ? (
        <img src={image} alt={title} className="projects-page__card-preview" />
      ) : (
        <iframe 
          src={link} 
          title={title}
          className="projects-page__card-preview"
          loading="lazy"
        />
      )}
    </div>
  );

  const handleClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className={`projects-page__card projects-page__card--${imagePosition}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      {imagePosition === 'left' && imageContent}

      <div className="projects-page__card-content">
        <div className="projects-page__card-text">        
          <h3 className="projects-page__card-title">{title}</h3>
          <p className="projects-page__card-description">{description}</p>
        </div>

        <div className="projects-page__card-tech">
          {technologies.map((tech) => (
            <span key={tech} className="projects-page__card-tech-tag">
              {tech}
            </span>
          ))}
        </div>
      </div>

      {imagePosition === 'right' && imageContent}
    </div>
  );
};

const ProjectsPage = () => {
  const { t, language } = useLanguage();
  const projectsData = getProjectsWithTranslations(language);

  return (
    <div className="projects-page-wrapper">
      <Header />
      
      <main className="projects-page">
        <div className="projects-page__container">
          {/* Header */}
          <div className="projects-page__header">
            <div className="projects-page__header-inner">
              <div className="projects-page__tag">
                <p className="projects-page__tag-text">{t('projectsPage.tag')}</p>
              </div>
            </div>

            <div className="projects-page__header-subtitle">
              <h1 className="projects-page__title">
                {t('projectsPage.title')}
              </h1>
              <p className="projects-page__subtitle">
                {t('projectsPage.description')}
              </p>
            </div>
          </div>

          {/* Projects Grid */}
          <div className="projects-page__list">
            {projectsData.map((project) => (
              <ProjectCard key={project.id} {...project} />
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProjectsPage;
